import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { Link } from "react-router-dom";
import { clearUser } from '../../store/userSlice';

import axios from "axios";
import config from '../../config';

import '../../styles/userProfile.css';

import EditProfileForm from "../forms/editProfileForm";

const ProfileDropdown = ({ user, role, account, property }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [editOverlayOpen, setEditOverlayOpen] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const API_URL = config.API_URL || 'http://localhost:5000';

    const accountName = user?.name || "User Name";
    const profilePicId = user?.profilePicture?._id;

    const cachedPic = localStorage.getItem(`profilePic_${user?.id}`);
    const profilePicSrc = cachedPic || user?.profilePicture?.key || "/default-user.png";

    const handleLogout = async () => {
        try {
            await axios.post(
                `${API_URL}/v2/auth/logout`,
                {},
                { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
            );

            // Clear user from Redux store
            dispatch(clearUser());

            // Redirect to login page
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    return (
        <div className="profile-dropdown">
            <img
                key={profilePicId}
                src={profilePicSrc}
                className="user-pic"
                alt="user-profile-pic"
                onClick={toggleMenu}
                style={{ cursor: "pointer" }}
            />
            <div className={`sub-menu-wrap ${menuOpen ? "open-menu" : ""}`} id="subMenu">
                <div className="sub-menu">
                    <div className="user-info">
                        <img
                            key={profilePicId}
                            src={profilePicSrc}
                            className="user-pic"
                            alt="user-profile-pic-sm"
                            onClick={toggleMenu}
                            style={{ cursor: "pointer" }}
                        />
                        <h2>{accountName}</h2>
                    </div>
                    <hr />

                    {role === "tenant" || role === "owner" ? (
                        <Link to="/dashboard" onClick={() => setMenuOpen(false)}>
                            <div className="sub-menu-link">
                                <i className="fa fa-home" style={{ marginRight: "20px" }}></i>
                                <p>Home</p>
                                <span><i className="fa fa-chevron-right" style={{ fontSize: "14px" }}></i></span>
                            </div>
                        </Link>
                    ) : (
                        <Link to="/dashboard" onClick={() => setMenuOpen(false)}>
                            <div className="sub-menu-link">
                                <i className="fa fa-chart-simple" style={{ marginRight: "20px" }}></i>
                                <p>Dashboard</p>
                                <span><i className="fa fa-chevron-right" style={{ fontSize: "14px" }}></i></span>
                            </div>
                        </Link>
                    )}

                    <Link className="sub-menu-link" onClick={() => { setEditOverlayOpen(true); setMenuOpen(false); }}>
                        <i className="fa fa-edit" style={{ marginRight: "20px" }}></i>
                        <p>Edit Profile</p>
                        <span><i className="fa fa-chevron-right" style={{ fontSize: "14px" }}></i></span>
                    </Link>
                    <Link className="sub-menu-link" style={{ marginBottom: "5px" }} onClick={() => { handleLogout(); setMenuOpen(false); }}>
                        <i className="fa fa-sign-out" style={{ marginRight: "20px" }}></i>
                        <p>Logout</p>
                        <span><i className="fa fa-chevron-right" style={{ fontSize: "14px" }}></i></span>
                    </Link>
                </div>
            </div>
            {editOverlayOpen && (
                <EditProfileForm
                    onClose={() => setEditOverlayOpen(false)}
                    user={user?.user?.userData}
                    account={account}
                    property={property}
                />
            )}
        </div>
    );
}

export default ProfileDropdown;